import { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { API } from '@aws-amplify/api';


// https://www.freecodecamp.org/news/how-to-build-forms-in-react/
export default function Joiner({ucs}) {
  //const [formData, setFormData] = useState({customer: ucs.customer.name.customer_name,joineridentfier: ucs.customer.name.customer_id,joinerpassword: "", joinerconfirm: "", joinershow: "block", joinercred: "", joinerupdated:""});

  const [inputError, setInputError] = useState(null);
  console.log('ucs derived in', ucs);
  var var2 = ucs;
  // console.log('var 2 obj-->',var2,"<---") 
  //console.log('var 2-->',JSON.stringify(var2),"<---") 
  //console.log('json.stringified passed prop-->',JSON.stringify(ucs),"<---")
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [creds, setCreds] = useState();

  async function saveCustomerData(customerCred) {
    console.log('starting the save',customerCred)
    var customerCredOut = customerCred.key;
    var return_object = {key:customerCredOut,cust_id:ucs.customer.customer_id.S}
    const apiName = 'api60cb0321';
    const path = '/customer/joiner';
    const body = JSON.stringify(return_object);
    const myInit = {
      body: return_object, // replace this with attributes you need
      headers: {} // OPTIONAL
    };
    return await API.post(apiName, path, myInit);
  }
  

  function credCalc(u,p){
    console.log('called cred calculator')
    var creds = document.getElementById('creds');
    var decodedStringBtoA = u + ":" + p
    //creds.value =  btoa(decodedStringBtoA);
    var concatted = btoa(decodedStringBtoA) + "###" + encodeURI(btoa(decodedStringBtoA));
    console.log(concatted);
    creds.value = concatted;
  }

  const handleUsernameChange = (event) => {
    console.log('username now',event.target.value);   
    var save_button = document.getElementById('saveButton')
    if (event.target.value.length > 7)
    {
      setUsername(event.target.value);
    } else{
      save_button.style.visible = 'none';      
    }
  };

  const handlePasswordChange = (event) => {
    console.log('password now vlaue', event.target.value);
    var password = event.target.value;
    var username = document.getElementById('joinername')  
    var confirm = document.getElementById('joinerconfirm')
    var password_now = document.getElementById('joinerpassword')
    var save_button = document.getElementById('saveButton')
    console.log(password_now.value,confirm.value);
    if (password_now.value !== confirm.value){
      console.log('not match');
      save_button.style.visible = 'none';      
    } else {      
      console.log(' match!');      
      save_button.style.display='block';
      
    }
  };

  function handleInputChange(event) {
    const { name, value } = event.target;
    console.log('change in',name);    
    var new_data = {name: event.target.value}
    //setFormData(new_data)
    if (name === "joineridentfier") {
      if (value.length < 1) {
        setInputError('Name must be at least 1 characters');
      } else {
        setInputError(null);        
      }
    } 

    if (name === "joinerpassword") {
      if (value.length < 8) {
        setInputError('Password must be at least 8 characters');
      } else {
        setInputError(null);
      }
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    var password_now = document.getElementById('joinerpassword')
    var cred_string = ucs.customer.customer_id.S + ";" + password_now.value;
    console.log(cred_string);
    var u = btoa(cred_string);
    var cleansed = u.replace(/=/g, "");
    console.log('saving b64->',cleansed,'<-');
    saveCustomerData({key:cleansed},{customer_id:ucs.customer.customer_id});   
  }

return (
  <div>
  <h2>Cloud ID Settings</h2>   
  <form onSubmit={handleSubmit}>

  <h4>CUSTOMER:{ucs.customer.customer_name.S}</h4>
        <h4>USER:{ucs.user.user_email.S}</h4> 
        <h4>USER ID:{ucs.user.user_id.S}</h4> 

        

    <p type="text" id="joinjoinerupdatedercustomer" name="joinerupdated" value={JSON.stringify(ucs)} /><br></br>    
    <h1>Cloud ID:{ucs.customer.customer_id.S} </h1><br></br>
    <div>

    <h1 id="joineridentfier" name="joineridentfier" value={ucs.customer.customer_id.S} /><br></br>
    <label htmlFor="email">Cloud Password:</label>
    <input type="text" id="joinerpassword" name="joinerpassword"  onChange={handleInputChange}/>
    <label htmlFor="confirm">Confirm Cloud Password:</label>
    <input type="text" id="joinerconfirm" name="joinerconfirm"  onChange={handleInputChange}/><br></br>
    {inputError && <div style={{ color: 'red' }}>{inputError}</div>}
    <button id="submitgood" type="submit" >Submit</button>
    </div>
  </form>
  </div>
);
}